import { faEdit, faEye } from '@fortawesome/free-regular-svg-icons';
import { faCircleCheck, faCircleExclamation, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Badge, Button, Col, Container, Form, Modal, Row, Table } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import ActivityLog from '../ActivityLog';
import * as Common from "../Common";
import Dialog from '../Dialog';
import DialogYesNo from '../Dialog_Yes_No';
import LoginHeader from '../Login_header';
import Master_agent_linking from '../master/financial/Master_agent_linking';
import Menu from '../Menu';
import * as Picklist from "../Picklist";
import Tran_commission_gst_approval from './Tran_commission_gst_approval';

function Tran_commission_module() {
    const flag = true;

    const sid = sessionStorage.getItem("sessionId");
    const navigate = useNavigate();
    const finfromdate = sessionStorage.getItem("startDate");
    const fintodate = sessionStorage.getItem("endDate");
    const branchDisable = sessionStorage.getItem('branchDisable');

    //#region All right states
    const [userRight, setUserRight] = useState([]);
    const [bmApprovalRight, setBMApprovalRight] = useState([]);
    const [gstApprovalRight, setGstApprovalRight] = useState([]);
    const [gstApproval2Right, setGstApproval2Right] = useState([]);
    const [zmApprovalRight, setZMApprovalRight] = useState([]);
    //#endregion all right states
    const [cmLocation, setCMLocation] = useState(null);
    const [radioType, setRadioType] = useState("N");
    const [srnoFrom, setSrnoFrom] = useState("");
    const [srnoTo, setSrnoTo] = useState("");
    const [frmDate, setFrmDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [scrMode, setScrMode] = useState("");
    const [msgText, setMsgText] = useState("");
    const [isMsgBox, setMsgBox] = useState(false);

    const [cmLocationValue, setCMLocationValue] = useState("");
    const [cmStateValue, setCMStateValue] = useState("");
    const [hdrLocation, setHdrLocation] = useState("");
    const [nFile, setNFile] = useState("");
    const [commissionData, setCommissionData] = useState([]);
    const [tranType, setTranType] = useState("A");
    const [searchFilter, setSearchFilter] = useState("");
    const [childRadioType, setChildRadioType] = useState("U");

    const [approvalStatusFilter, setApprovalStatusFilter] = useState("P");
    const [frmApprovalDate, setFrmApprovalDate] = useState(new Date());
    const [toApprovalDate, setToApprovalDate] = useState(new Date());

    const [hdrData, setHdrData] = useState([]);
    const [hdrSrno, setHdrSrno] = useState("");
    const [hdrDate, setHdrDate] = useState("");
    const [hdrFromDate, setHdrFromDate] = useState("");
    const [hdrFromDateDMY, setHdrFromDateDMY] = useState("");
    const [hdrToDate, setHdrToDate] = useState("");
    const [hdrToDateDMY, setHdrToDateDMY] = useState("");
    const [isMsgBoxFinal, setMsgBoxFinal] = useState(false);
    const [msgTextFinal, setMsgTextFinal] = useState("");
    const [bmDetailData, setBMDetailData] = useState([]);
    const [filterStatus, setFilterStatus] = useState("1");
    const [bmStatus, setBMStatus] = useState("");
    const [bmLineNo, setBmLineNo] = useState("");
    const [finalMsgSrc, setFinalMsgSrc] = useState("");

    const [reportType, setReportType] = useState("OC");

    const [BMHeaderData, setBMHeaderData] = useState([]);
    const [gstData, setGstData] = useState([]);

    const [bmAppTotalPayable, setBmAppTotalPayable] = useState("");
    const [bmAppTotalCommission, setBmAppTotalCommission] = useState("");
    const [bmAppTotalTds, setBmAppTotalTds] = useState("");
    const [bmAccount, setBmAccount] = useState("");
    const [bmIfsc, setBmIfsc] = useState("");
    const [bmAppAccName, setBmAppAccName] = useState("");
    const [bmAppAgent, setBmAppAgent] = useState("");
    const [bmFaType, setBmFaType] = useState("");
    const [bmGSTType, setBmGSTType] = useState("");
    const [bmGST, setBmGST] = useState("");
    const [bmAgentCode, setBmAgentCode] = useState("");

    const [selectAll, setSelectAll] = useState(false);

    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [showActivityLog, setShowActivityLog] = useState(false);

    const [agentProps, setAgentProps] = useState('');
    const [showAgentForm, setShowAgentForm] = useState(false);
    const [commissionSummary, setCommissionSummary] = useState([]);
    const [summaryCommissionTotal, setSummaryCommissionTotal] = useState("");
    const [summaryPayable, setSummaryPayable] = useState("");
    const [summaryTDSTotal, setSummaryTDSTotal] = useState("");

    const [holdGstData, setHoldGstData] = useState([]);
    const [showSummaryModal, setShowSummaryModal] = useState(false);
    const [gstStatus, setGstStatus] = useState("");
    const [propObject, setPropObject] = useState({});
    const [paymentType, setPaymentType] = useState("");
    const [approvalType, setApprovalType] = useState("");
    const [hdrGstin, setHdrGstin] = useState("");

    const [showInvoiceModal, setShowInvoiceModal] = useState(false);
    const [invoiceData, setInvoiceData] = useState([]);
    const [faDownloadType, setFaDownloadType] = useState("N");
    const [faType, setFaType] = useState("");
    const [openFaModal, setOpenFaModal] = useState(false);
    const [openApprovalModal, setOpenApprovalModal] = useState(false);
    const [approvalSummary, setApprovalSummary] = useState([]);

    const [bmInvoiceDate, setBmInvoiceDate] = useState("");
    const [bmInvoiceNum, setBmInvoiceNum] = useState("");

    const [selectAllBM, setSelectAllBM] = useState(false);
    const [summaryStatusFilter, setSummaryStatusFilter] = useState("O");

    const [filterGstType, setFilterGstType] = useState("1");
    const [newRemark, setNewRemark] = useState("");
    const [allLocationSelector, setAllLocationSelector] = useState("O");
    const [hgstFilterStatus, setHgstFilterStatus] = useState("P");

    const [showFaSummary, setShowFaSummary] = useState(false);
    const [faSummary, setFaSummary] = useState([]);

    const [isMsgBoxFinalFaWrite, setMsgBoxFinalFaWrite] = useState(false);
    const [msgTextFinalFaWrite, setMsgTextFinalFaWrite] = useState("");

    useEffect(() => {
        Common.getActiveBranch().then(response => {
            setCMLocation(response);
            response != null && handleLocationChange(response);
        });
        Promise.all([
            Common.callApiPromise(Common.apiRight, [sid, 'all', 'TRAN_COMMISSION']),
            Common.callApiPromise(Common.apiRight, [sid, 'all', 'TRAN_COMMISSION_BM_APPROVAL']),
            Common.callApiPromise(Common.apiRight, [sid, 'all', 'TRAN_COMMISSION_ZM_APPROVAL']),
            Common.callApiPromise(Common.apiRight, [sid, 'all', 'TRAN_COMMISSION_GST']),
            Common.callApiPromise(Common.apiRight, [sid, 'all', 'TRAN_COMMISSION_GST_APPROVAL'])
        ])
            .then(([userResp, bmResp, zmResp, gstResp, gstApprovalResp]) => {
                if (userResp.query == "0") navigate("/");
                setRadioType('A');
                setUserRight(userResp);
                setBMApprovalRight(bmResp);
                setZMApprovalRight(zmResp);
                setGstApprovalRight(gstResp);
                setGstApproval2Right(gstApprovalResp);
                if (bmResp.query == "1" || zmResp.query == "1") setRadioType("A");
                if (gstResp.query == "1" || gstApprovalResp == "1") setRadioType("H");
                if (userResp.add == "1") {
                    setRadioType("S");
                    setSrnoFrom(1);
                    setSrnoTo(30);
                    listCommissionHeader("1", 1, 30, sessionStorage.getItem("activeBranch"));
                }
            })
            .catch(error => alert(error));
    }, []);

    // #region Others
    const showSearchOptions = () => {
        setMsgBox(true);
        setMsgText("Search on : Agent Number, Agent Name");
    }

    const downloadDirectExpenseFormat = () => {
        const obj = {
            downloadType: "directexpensecommission",
            pageright: "TRAN_COMMISSION"
        }
        Common.callDownloadApiPost(Common.apiFormat, "post", [sid, "directexpensecommission", JSON.stringify(obj)]);
    }

    const btnActivityLog = (viewtype) => {
        setShowActivityLog(true);
        setLogObject({ trantype: "CM", trannumber: hdrSrno, trancategory: "T", location: cmLocationValue });
    }

    const handleLocationChange = (value) => {
        setHdrData([]);
        setBMHeaderData([]);
        setHoldGstData([]);
        setGstData([]);
        setCMLocation(value);
        var id = value.id;
        var location = id.split("^");
        setCMLocationValue(location[1]);
        setCMStateValue(location[3] == null ? 0 : location[3]);
        //setPPStateType(location[4]);
        //setPPStateName(location[5] == "" ? "Select" : location[5]);
        setHdrLocation(location[2]);
        sessionStorage.activeBranch = location[1];
    }
    // #endregion Others



    //#region AM Work ****************************************************
    const uploadFile = () => {
        $(".loader").show();
        var msg = [], i = 0;
        var selectedFile = document.getElementById('uploadCommission').files[0];
        if (cmLocation == null) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (cmLocation == null ? "Location." : "");
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (selectedFile == undefined) {
            $('.loader').hide();
            setMsgText("Please select a file to upload.");
            setMsgBox(true);
        } else if ((selectedFile.name.split('.')).length > 2) {
            $('.loader').hide();
            setMsgText("(.) not allowed in file name.");
            setMsgBox(true);
        } else if (selectedFile.name.split('.')[1] !== "xlsx") {
            $('.loader').hide();
            setMsgText("File extension must be xlsx.");
            setMsgBox(true);
        } else if (selectedFile.size > 10 * 1024 * 1024) {  // 10 MB
            $('.loader').hide();
            setMsgText("Please select a file with in 10 MB size.");
            setMsgBox(true);
        } else {
            setCommissionData([]);
            const obj = {
                sid: sid,
                pageright: "TRAN_COMMISSION",
                uploadType: "uploadcommission",
                location: cmLocationValue,
                locationname: hdrLocation,
                frmDate: hdrFromDate,
                toDate: hdrToDate,
                reportType: reportType,
                hdrsrno: hdrSrno,
                type: "CM",
                filename: nFile,
                commissionData: commissionData,
                state: cmStateValue
            }
            Common.uploadApi(JSON.stringify(obj), "uploadCommission", (result) => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                setMsgBox(true);
                setMsgText(resp.msg);
                setCommissionData(resp.docdetail);
                setNFile("");
            });
        }
    }

    //#region Header
    const headerSaveCheck = () => {
        setMsgBoxFinal(true);
        setMsgTextFinal(`Do you want to create entry for period ${Common.dateDMY(frmDate)} to ${Common.dateDMY(toDate)}.`);
        setFinalMsgSrc("A");
    }

    const addNewHeader = () => {
        //setScrMode("A");
        var msg = [], i = 0;
        var frmdateymd = Common.dateYMD(frmDate);
        var todateymd = Common.dateYMD(toDate);
        if (frmDate == null || toDate == null || cmLocation == null) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (cmLocation == null ? "Location" : "");
            msg[i++] = (frmDate == null ? "From date" : "");
            msg[i++] = (toDate == null ? "To date" : "");
            setMsgBox(true);
            setMsgText(Common.buildMessageFromArray(msg));
        } else if (frmdateymd < finfromdate || todateymd > fintodate) {
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0010"));
        } else {
            const obj = {
                location: cmLocationValue,
                todate: Common.dateYMD(toDate),
                frmdate: Common.dateYMD(frmDate),
                frmsrno: srnoFrom,
                radioType: radioType,
                tosrno: srnoTo,
                newRemark: newRemark
            }
            Common.callApi(Common.apiCommission, [sid, "saveheader", JSON.stringify(obj)], result => {
                setHdrData(JSON.parse(result));
            });
        }
    }

    const viewHeaderDetails = (hdrsrno, location, btnsource) => {
        $(".loader").show();
        setInvoiceData([]);
        setHdrSrno(hdrsrno);
        setHdrDate("dd-mm-yyyy");
        setSearchFilter("");
        setNFile("");
        setFilterGstType("1");
        const obj = {
            hdrsrno: hdrsrno,
            location: location,
            state: cmStateValue,
            btnsource: btnsource
        }
        Common.callApi(Common.apiCommission, [sid, "hdrdetails", JSON.stringify(obj)], result => {
            $(".loader").hide();
            setScrMode("Q");
            let resp = JSON.parse(result);
            let hdrdata = resp.hdrdata[0];
            setHdrFromDate(hdrdata.hdr_from_date);
            setHdrToDate(hdrdata.hdr_to_date);
            setHdrFromDateDMY(hdrdata.hdr_from_date_dmy);
            setHdrToDateDMY(hdrdata.hdr_to_date_dmy);
            setCommissionData(resp.commdata);
        });
    }

    const listCommissionHeader = (src = "0", fromsrno, tosrno, activelocation) => {
        $(".loader").show();
        setBMHeaderData([]);
        setGstData([]);
        const obj = {
            radioType: radioType,
            frmdate: Common.dateYMD(frmDate),
            todate: Common.dateYMD(toDate),
            frmsrno: src == "0" ? srnoFrom : fromsrno,
            tosrno: src == "0" ? srnoTo : tosrno,
            type: tranType,
            location: src == "0" ? cmLocationValue : activelocation
        }
        var msg = [], i = 0;
        var frmdateymd = Common.dateYMD(frmDate);
        var todateymd = Common.dateYMD(toDate);
        if (radioType == "S" && (srnoFrom == "" || srnoTo == "")) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (srnoFrom == null ? "From Srno" : "");
            msg[i++] = (srnoTo == null ? "To Srno" : "");
            setMsgBox(true);
            setMsgText(Common.buildMessageFromArray(msg));
        } else if (radioType == "D" && (frmdateymd < finfromdate || todateymd > fintodate)) {
            $(".loader").hide();
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0010"));
        } else {
            Common.callApi(Common.apiCommission, [sid, "listheader", JSON.stringify(obj)], result => {
                $(".loader").hide();
                //console.log(result);
                //setCommissionData(JSON.parse(result));
                setHdrData(JSON.parse(result));
            });
        }
    }
    //#endregion Header




    //#region Detail Work
    const finalDeleteBox = () => {
        setMsgBoxFinal(true);
        setMsgTextFinal("Do you really want to delete the selected records?");
        setFinalMsgSrc("D");
    }

    const finalCheck = () => {
        setMsgBoxFinal(false);
        if (finalMsgSrc == "D") deleteChecked();
        else if (finalMsgSrc == "A") addNewHeader();
    }

    const handleFileChange = (v) => {
        setNFile(v);
    }

    const handleSelectAll = (ischecked) => {
        setSelectAll(ischecked);
        var newArr = [];
        if (ischecked) {
            newArr = commissionData.map(item => {
                // if (item.det_submit_approval == "0")
                return { ...item, 'selected': item.det_submit_approval == "1" || item.det_fa_type == 'NOFA' ? '0' : "1" };
            });
        } else {
            newArr = commissionData.map(item => {
                // if (item.det_submit_approval == "0")
                return { ...item, 'selected': '0' };
            });
        }
        console.log(newArr);
        setCommissionData(newArr);
    }

    const updateCheckChanges = (name, index, e) => {
        let newArr = commissionData.map((item, i) => {
            if (index == i) {
                if (name == "selected") {
                    setSelectAll(false);
                    if (e.target.checked) return { ...item, [name]: '1' }
                    else return { ...item, [name]: '0' }
                }
            } else {
                return item;
            }
        });
        setCommissionData(newArr);
    }

    const deleteChecked = () => {
        $(".loader").show();
        const obj = {
            hdrsrno: hdrSrno,
            location: cmLocationValue,
            radioType: radioType,
            frmdate: Common.dateYMD(frmDate),
            todate: Common.dateYMD(toDate),
            frmsrno: srnoFrom,
            tosrno: srnoTo,
            type: tranType,
            searchFilter: searchFilter.trim(),
            filterStatus: filterStatus,
            filterGstType: filterGstType,
            fetchCommission: Common.fetchCommission
        }
        var err = "Please select transactions.";
        var filteredCommission = commissionData.map(item => {
            if (item.selected == "1") {
                err = "";
                if (item.det_status == "A") err = "Not able to delete, transaction with certno " + item.det_cert_no + " already approved.";
                return [item.det_cert_no, item.det_lineno, item.det_location, item.det_srno, item.det_type, item.det_product_srno, item.det_product_line_no];
            }
        }).filter(item => item != undefined);

        if (err !== "") {
            $(".loader").hide();
            setMsgBox(true);
            setMsgText(err);
        } else {
            Common.callApi(Common.apiCommission, [sid, "delete", JSON.stringify(filteredCommission), JSON.stringify(obj)], result => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                if (resp.status) {
                    setCommissionData(resp.commissiondata);
                    setSelectAll(false);
                } else {
                    setMsgBox(true);
                    setMsgText(resp.message);
                }
            });
        }
    }

    const openSendForApprovalModal = () => {
        $(".loader").show();
        var count = 0;
        for (var i = 0; i < commissionData.length; i++) {
            if (commissionData[i].selected == "1") {
                count++;
                break;
            }
        }
        if (count > 0) {
            setOpenApprovalModal(true);
            $(".loader").show();
            const obj = {
                hdrsrno: hdrSrno,
                location: cmLocationValue,
                commissionData: commissionData,
                searchFilter: searchFilter.trim(),
                filterStatus: filterStatus,
                filterGstType: filterGstType
            }
            Common.callApi(Common.apiCommission, [sid, "getapprovalsummary", JSON.stringify(obj)], result => {
                $(".loader").hide();
                setApprovalSummary(JSON.parse(result));
            });
        } else {
            $(".loader").hide();
            setMsgBox(true);
            setMsgText("Please select one or more agent.");
        }
    }

    const sendForApproval = () => {
        $(".loader").show();
        const obj = {
            hdrsrno: hdrSrno,
            location: cmLocationValue,
            commissionData: commissionData,
            searchFilter: searchFilter.trim(),
            filterStatus: filterStatus,
            filterGstType: filterGstType
        }
        var isOk = false;
        var err = "Please select transactions.";
        for (var i = 0; i < commissionData.length; i++) {
            if (commissionData[i].selected == "1") {
                isOk = true;
                err = "";
            }
            if (commissionData[i].selected == "1" && commissionData[i].det_status != "O") {
                isOk = false;
                err = "Please mark OK to each transaction before sending it to BM.";
                break;
            }
            if (commissionData[i].selected == "1" && commissionData[i].det_status == "O") {
                if ((commissionData[i].det_gst_type == "WGST" || commissionData[i].det_gst_type == "HGST") &&
                    (commissionData[i].det_agent_invoice_num == "" || commissionData[i].det_agent_invoice_date == null)) {
                    isOk = false;
                    err = "Please fill invoice details of transactions with WGST and HGST records.";
                    break;
                }
            }
        }
        if (isOk) {
            Common.callApi(Common.apiCommission, [sid, "sendtoapproval", JSON.stringify(obj)], result => {
                $(".loader").hide();
                //console.log(result);
                let resp = JSON.parse(result);
                setCommissionData(resp.commdata);
                setMsgBox(true);
                setMsgText(resp.msg);
            });
        } else {
            $(".loader").hide();
            setMsgBox(true);
            setMsgText(err);
        }
        setOpenApprovalModal(false);
        handleSelectAll(false);
    }

    const updateStatus = (status, srno, lineno, location, certno, type) => {
        handleSelectAll(false);
        $(".loader").show();
        const obj = {
            status: status,
            trannumber: srno,
            lineno: lineno,
            location: location,
            certno: certno,
            type: type,
            searchFilter: searchFilter.trim(),
            filterStatus: filterStatus,
            paytype: "COMMISSION",
            filterGstType: filterGstType
        }
        Common.callApi(Common.apiCommission, [sid, "updatestatus", JSON.stringify(obj)], result => {
            $(".loader").hide();
            let resp = JSON.parse(result);
            setCommissionData(resp.commissiondata);
        });
    }

    const handleSearchChange = (v) => {
        Common.validateAlpNumSplValue(v, setSearchFilter);
    }

    const searchCommission = (srchtype) => {
        $(".loader").show();
        handleSelectAll(false);
        if (srchtype == "R") {
            setSearchFilter("");
            setFilterGstType("1");
            setFilterStatus("1");
        }
        const obj = {
            hdrsrno: hdrSrno,
            location: cmLocationValue,
            searchFilter: srchtype == "R" ? "" : searchFilter.trim(),
            filterStatus: srchtype == "R" ? "1" : filterStatus,
            filterGstType: srchtype == "R" ? "1" : filterGstType
        }
        Common.callApi(Common.apiCommission, [sid, "filtersearch", JSON.stringify(obj)], result => {
            $(".loader").hide();
            setCommissionData(JSON.parse(result));
        });
    }

    const agentDetailsForm = (agentcode) => {
        setShowAgentForm(true);
        setAgentProps({ agentcode: agentcode, location: cmLocationValue, locationname: hdrLocation, setShowAgentForm: setShowAgentForm });
    }

    const updateAgentDetails = (agentcode) => {
        viewHeaderDetails(hdrSrno, cmLocationValue, "0");
    }

    const summarizeCommission = (v) => {
        $(".loader").show();
        setSummaryStatusFilter(v);
        setShowSummaryModal(true);
        const obj = {
            hdrsrno: hdrSrno,
            location: cmLocationValue,
            listtype: "summary",
            statusfilter: v
        }
        Common.callApi(Common.apiCommission, [sid, "summary", JSON.stringify(obj)], result => {
            $(".loader").hide();
            let res = JSON.parse(result);
            setCommissionSummary(res.data);
            setSummaryCommissionTotal(res.totalcommission);
            setSummaryTDSTotal(res.totaltds);
            setSummaryPayable(res.netcommission);
        });
    }

    const downloadSummary = () => {
        const obj = {
            hdrsrno: hdrSrno,
            location: cmLocationValue,
            listtype: "summary",
            statusfilter: summaryStatusFilter
        }
        Common.callDownloadApiPost(Common.apiCommission, "post", [sid, "summarydownload", JSON.stringify(obj)]);
    }
    //#endregion Detail Word




    //#region Invoice details
    const updateInvoice = () => {
        var count = 0;
        for (var i = 0; i < commissionData.length; i++) {
            if (commissionData[i].selected == "1") {
                count++;
                break;
            }
        }
        if (count < 1) {
            setMsgBox(true);
            setMsgText("Please select one or more agent to update invoice details.");
        } else {
            setShowInvoiceModal(true);
            const obj = {
                hdrsrno: hdrSrno,
                location: cmLocationValue,
                commissionData: commissionData,
                listtype: "invoice",
                searchFilter: searchFilter.trim(),
                filterStatus: filterStatus,
                filterGstType: filterGstType
            }
            Common.callApi(Common.apiCommission, [sid, "invoicedetails", JSON.stringify(obj)], result => {
                let res = JSON.parse(result);
                setInvoiceData(res);
            });
        }
    }

    const updateInvoiceValues = (val, index, name) => {
        let newArr = invoiceData.map((item, i) => {
            if (i == index) {
                if (name == "invoicenum") {
                    return { ...item, [name]: val }
                } else if (name == "invoicedate") {
                    return { ...item, [name]: val }
                }
            } else {
                return item;
            }
        });
        //console.log(newArr);
        setInvoiceData(newArr);
    }

    const finalUpdateInvoice = () => {
        $(".loader").show();
        var isOk = true;
        if (isOk) {
            const obj = {
                invoiceData: invoiceData,
                hdrsrno: hdrSrno,
                location: cmLocationValue,
                searchFilter: searchFilter.trim(),
                filterStatus: filterStatus,
                filterGstType: filterGstType
            }
            Common.callApi(Common.apiCommission, [sid, "updateinvoice", JSON.stringify(obj)], result => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                handleSelectAll(false);
                setShowInvoiceModal(false);
                setCommissionData(resp.data);
                setMsgBox(true);
                setMsgText(resp.msg);
            });
        } else {
            $(".loader").hide();
            handleSelectAll(false);
            setShowInvoiceModal(false);
            setMsgBox(true);
            setMsgText("Please select one or more agent to update invoice details.");
        }
    }
    //#endregion Invoice details




    //#region FA Download
    const downloadFAModal = (fatype) => {
        setOpenFaModal(true);
        setFaType(fatype);
    }

    const finalDownloadFa = () => {
        const obj = {
            fatype: faType,
            faDownloadType: faDownloadType,
            location: cmLocationValue,
            hdrsrno: hdrSrno
        }
        Common.callDownloadApiPost(Common.apiCommission, "post", [sid, "downloadfa", JSON.stringify(obj)]);
        setOpenFaModal(false);
    }
    //#endregion FA Download




    //#region Hold GST
    const listHoldHGST = () => {
        $(".loader").show();
        setBMHeaderData([]);
        setHdrData([]);
        const obj = {
            location: cmLocationValue,
            allLocationSelector: allLocationSelector,
            hgstFilterStatus: hgstFilterStatus
        }
        Common.callApi(Common.apiCommission, [sid, "listgst", JSON.stringify(obj)], result => {
            $(".loader").hide();
            setGstData(JSON.parse(result));
        });
    }

    const viewHoldGstDetails = (agentcode, srno, location, agentname, sgst, cgst, igst, gstin, invoicenum, invoicedate) => {
        $(".loader").show();
        setHdrSrno(srno);
        setScrMode("GST");
        const obj = {
            agentcode: agentcode,
            hdrsrno: srno,
            location: location,
            holdgstlist: true
        }
        Common.callApi(Common.apiCommission, [sid, "viewholdgst", JSON.stringify(obj)], result => {
            $(".loader").hide();
            var resp = JSON.parse(result);
            setHoldGstData(resp);
        });
        setPropObject({
            hdrsrno: srno,
            setScrMode: setScrMode,
            setHoldGstData: setHoldGstData,
            gstStatus: gstStatus,
            agentcode: agentcode,
            agentname: agentname,
            location: hdrLocation,
            cgst: cgst,
            sgst: sgst,
            igst: igst,
            setMsgBox: setMsgBox,
            setMsgText: setMsgText,
            cmLocationValue: cmLocationValue,
            gstin: gstin,
            invoicenum: invoicenum,
            invoicedate: invoicedate
        });
    }
    //#endregion Hold GST
    //#endregion AM Work****************************************************



    // #region BM/ZM Work****************************************************
    const bmHdrList = (paytype, approvaltype) => {
        setGstData([]);
        setHdrData([]);
        setPaymentType(paytype);
        setApprovalType(approvaltype);
        handleSelectAllBM(false);
        $(".loader").show();
        const obj = {
            location: cmLocationValue,
            paytype: paytype,
            approvalType: approvaltype,
            frmApprovalDate: Common.dateYMD(frmApprovalDate),
            toApprovalDate: Common.dateYMD(toApprovalDate),
            approvalStatusFilter: approvalStatusFilter,
            allLocationSelector: allLocationSelector,
            hgstFilterStatus: hgstFilterStatus
        }
        if (approvalStatusFilter == "A" && (frmApprovalDate == null || toApprovalDate == null)) {
            $(".loader").hide();
            setMsgBox(true);
            setMsgText("Please fill from-to date range.");
        } else {
            Common.callApi(Common.apiCommission, [sid, "bmlist", JSON.stringify(obj)], result => {
                $(".loader").hide();
                setHdrData([]);
                setBMHeaderData(JSON.parse(result));
            });
        }
    }

    const viewBMHdrDetails = (item) => {
        $(".loader").show();
        setGstStatus(item.app_hgst_status);
        setHdrSrno(item.app_srno);
        setBmLineNo(item.app_lineno);
        setScrMode("BmQ");
        setBMStatus(item.app_status);
        setBmAgentCode(item.app_agent_code);
        setBmAppTotalCommission(item.app_total_commission);
        setBmAppTotalTds(item.app_tds);
        setBmAppTotalPayable(item.app_payable);
        setBmAppAccName(item.app_account_name);
        setBmAppAgent(item.app_agent_code + ' ' + item.app_agent_name);
        setBmAccount(item.app_account_no);
        setBmIfsc(item.app_ifsc);
        setBmGSTType(item.app_gst_type);
        setBmFaType(item.app_fa_type);
        setBmGST(item.app_igst * 1 + item.app_cgst * 1 + item.app_sgst * 1);
        setHdrGstin(item.app_gstin);
        setBmInvoiceNum(item.app_agent_invoice_num);
        setBmInvoiceDate(item.app_agent_invoice_date);
        const obj = {
            hdrsrno: item.app_srno,
            location: item.app_location,
            agencode: item.app_agent_code,
            lineno: item.app_lineno,
            isbmlist: true,
            paytype: paymentType
        }
        Common.callApi(Common.apiCommission, [sid, "filtersearch", JSON.stringify(obj)], result => {
            $(".loader").hide();
            setBMDetailData(JSON.parse(result));
        });
    }

    const updateTransactionBMZM = (updatetype, allOne) => {
        $(".loader").show();
        // const hdrdetails = BMHeaderData.filter((item) => item.selective * 1 > 0);
        // console.log(hdrdetails);
        const obj = {
            hdrsrno: hdrSrno,
            location: cmLocationValue,
            updatetype: updatetype,
            bmLineNo: bmLineNo,
            bmAgentCode: bmAgentCode,
            paytype: paymentType,
            approvalType: approvalType,
            frmApprovalDate: Common.dateYMD(frmApprovalDate),
            toApprovalDate: Common.dateYMD(toApprovalDate),
            approvalStatusFilter: approvalStatusFilter,
            BMHeaderData: BMHeaderData,
            allOne: allOne,
            hgstFilterStatus: hgstFilterStatus,
            allLocationSelector: allLocationSelector
        }
        var isOk = true;
        if (allOne == 'A') {
            isOk = false;
            for (var i = 0; i < BMHeaderData.length; i++) {
                if (BMHeaderData[i].selected == "1") {
                    isOk = true;
                    break;
                }
            }
        }
        if (isOk) {
            Common.callApi(Common.apiCommission, [sid, "updatepaymentbm", JSON.stringify(obj)], result => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                if (resp.msg == "1") {
                    setScrMode("");
                    setBMHeaderData(resp.bmapprlist);
                }
            });
        } else {
            $(".loader").hide();
            setMsgBox(true);
            setMsgText("Please select transactions.");
        }
        handleSelectAllBM(false);
    }

    const handleSelectAllBM = (ischecked) => {
        setSelectAllBM(ischecked);
        var newArr = [];
        if (ischecked) {
            newArr = BMHeaderData.map(item => {
                // if (item.det_submit_approval == "0")
                if (approvalType == "BM")
                    return { ...item, 'selected': item.app_status == "P" ? '1' : "0" };
                else
                    return { ...item, 'selected': item.app_status == "B" ? '1' : "0" };
            });
        } else {
            newArr = BMHeaderData.map(item => {
                // if (item.det_submit_approval == "0")
                return { ...item, 'selected': '0' };
            });
        }
        setBMHeaderData(newArr);
    }

    const updateCheckChangesBM = (name, index, e) => {
        let newArr = BMHeaderData.map((item, i) => {
            if (index == i) {
                if (name == "selected") {
                    setSelectAllBM(false);
                    if (e.target.checked) return { ...item, [name]: '1' }
                    else return { ...item, [name]: '0' }
                }
            } else {
                return item;
            }
        });
        setBMHeaderData(newArr);
    }
    // #endregion BM/ZM Work****************************************************


    const hideActivityLog = () => {
        setShowActivityLog(false);
    }

    const handleAllLocationSelector = (e) => {
        setAllLocationSelector(e.target.value);
        setGstData([]);
        setBMHeaderData([]);
    }

    const handleFilterStatus = (v) => {
        setHgstFilterStatus(v);
        setGstData([]);
        setBMHeaderData([]);
    }

    const handleRadioTypeChange = (v) => {
        setRadioType(v);
        setAllLocationSelector("O");
        setBMHeaderData([]);
        setGstData([]);
        setHdrData([]);
    }



    function fetchCommssions() {
        const obj = {
            location: cmLocationValue,
            locationname: hdrLocation,
            frmDate: hdrFromDate,
            toDate: hdrToDate,
            reportType: reportType,
            hdrsrno: hdrSrno,
            type: "CM",
            commissionData: commissionData,
            state: cmStateValue
        }
        $(".loader").show();
        Common.callApi(Common.apiCommission, [sid, "fetchcommissions", JSON.stringify(obj)], result => {
            $(".loader").hide();
            let resp = JSON.parse(result);
            if (resp.err !== "") {
                setMsgBox(true);
                setMsgText(resp.msg);
            } else {
                setMsgBox(true);
                setMsgText(resp.msg);
                viewHeaderDetails(hdrSrno, cmLocationValue, "");
                //setCommissionData(resp.commdata);
            }
        });
    }


    function getFaDetail(v) {
        setFaType(v);
        const obj = {
            fatype: v,
            faDownloadType: "N",
            location: cmLocationValue,
            hdrsrno: hdrSrno
        }
        $(".loader").show();
        Common.callApi(Common.apiCommission, [sid, "fetchfacommission", JSON.stringify(obj)], result => {
            $(".loader").hide();
            //console.log(result);
            let resp = JSON.parse(result);
            if(resp.status){
                setShowFaSummary(true);
                setFaSummary(resp.faarray);
            }else{
                setMsgBox(true);
                setMsgText(resp.msg);
            }
        });
    }

    function writeFinancialEntry(v) {
        const obj = {
            fatype: faType,
            location: cmLocationValue,
            hdrsrno: hdrSrno,
            hdrToDate: hdrToDate,
            prevFaCheck: v
        }
        $(".loader").show();
        Common.callApi(Common.apiCommission, [sid, "writefa", JSON.stringify(obj)], result => {
            $(".loader").hide();
            let resp = JSON.parse(result);
            setShowFaSummary(false);
            setMsgBoxFinalFaWrite(false);
            if (resp.err == "") {
                setMsgBox(true);
                setMsgText(resp.msg);
            } else {
                if (resp.ynmsgbox == '1') {
                    setMsgBoxFinalFaWrite(true);
                    setMsgTextFinalFaWrite(faType + ' ' + resp.msg);
                } else {
                    setMsgBox(true);
                    setMsgText(resp.err);
                }
            }
        });
    }

    return (
        <>
            {
                showAgentForm ?
                    <Master_agent_linking cmmodule={agentProps} updateAgentDetails={updateAgentDetails} />
                    :
                    <>
                        <LoginHeader />
                        <Menu />
                        <Container fluid>
                            <Row>
                                <Col>
                                    <h2>Commission Module</h2>
                                    {/* <span>{counter}</span> */}
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            {
                                scrMode == "" ?
                                    <>
                                        <Row>
                                            {/* <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Location<span className="colorThemeRed">*</span></Form.Label>
                                                    <AsyncSelect
                                                        cacheOptions={false}
                                                        defaultOptions={false}
                                                        value={cmLocation}
                                                        getOptionLabel={e => e.label + ' '}
                                                        getOptionValue={e => e.id}
                                                        loadOptions={Picklist.fetchLocationAllowedPicklist}
                                                        onInputChange={Picklist.handleInputChange}
                                                        onChange={handleLocationChange}
                                                        isDisabled={branchDisable == "true"}
                                                    >
                                                    </AsyncSelect>
                                                </Form.Group>
                                            </Col> */}
                                            <Col className='col-md-5 col-12'>
                                                <Form.Group>
                                                    <Row style={{ marginTop: "30px" }}>
                                                        {
                                                            userRight.query == "1" &&
                                                            <>
                                                                {
                                                                    userRight.add == "1" &&
                                                                    <Col>
                                                                        <Form.Check checked={radioType == "N"} onChange={() => handleRadioTypeChange("N")} type='radio' label="New" />
                                                                    </Col>
                                                                }
                                                                <Col>
                                                                    <Form.Check checked={radioType == "S"} onChange={() => handleRadioTypeChange("S")} type='radio' label="SrNo" />
                                                                </Col>
                                                                <Col>
                                                                    <Form.Check checked={radioType == "D"} onChange={() => handleRadioTypeChange("D")} type='radio' label="Date" />
                                                                </Col>
                                                                {
                                                                    (gstApprovalRight.query == "1" || gstApproval2Right.query == "1") ?
                                                                        <Col>
                                                                            <Form.Check checked={radioType == "H"} onChange={() => handleRadioTypeChange("H")} type='radio' label="Hold GST" />
                                                                        </Col>
                                                                        : null
                                                                }

                                                                {
                                                                    (bmApprovalRight.query == "1" || zmApprovalRight.query == "1") ?
                                                                        <Col>
                                                                            <Form.Check checked={radioType == "A"} onChange={() => handleRadioTypeChange("A")} type='radio' label="Approve" />
                                                                        </Col>
                                                                        : null
                                                                }
                                                            </>
                                                        }
                                                    </Row>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            {radioType == "H" && gstApproval2Right.query == "1"
                                                ?
                                                <>
                                                    <Col className='col-md-2'>
                                                        <Form.Label>One/All</Form.Label>
                                                        <Form.Select value={allLocationSelector} onChange={e => handleAllLocationSelector(e)} >
                                                            <option value="O">One</option>
                                                            <option value="A">All</option>
                                                        </Form.Select>
                                                    </Col></> : null
                                            }
                                            <Col style={{ display: allLocationSelector == "A" && "none" }} className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Location<span className="colorThemeRed">*</span></Form.Label>
                                                    <AsyncSelect
                                                        cacheOptions={false}
                                                        defaultOptions={false}
                                                        value={cmLocation}
                                                        getOptionLabel={e => e.label + ' '}
                                                        getOptionValue={e => e.id}
                                                        loadOptions={Picklist.fetchLocationAllowedPicklist}
                                                        onInputChange={Picklist.handleInputChange}
                                                        onChange={handleLocationChange}
                                                        isDisabled={branchDisable == "true"}
                                                    >
                                                    </AsyncSelect>
                                                </Form.Group>
                                            </Col>
                                            {
                                                radioType == "N" || radioType == "D" || radioType == "T" ?
                                                    <>
                                                        <Col className='col-md-3 col-6'>
                                                            <Form.Group>
                                                                <Form.Label>From Date</Form.Label>
                                                                <DatePicker className="form-control"
                                                                    selected={frmDate}
                                                                    onChange={(date) => setFrmDate(date)}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    showYearDropdown
                                                                    showMonthDropdown
                                                                    useShortMonthInDropdown
                                                                    dropdownMode="select"
                                                                    peekNextMonth
                                                                    customInput={
                                                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                    }
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col className='col-md-3 col-6'>
                                                            <Form.Group>
                                                                <Form.Label>To Date</Form.Label>
                                                                <DatePicker className="form-control"
                                                                    selected={toDate}
                                                                    onChange={(date) => setToDate(date)}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    showYearDropdown
                                                                    showMonthDropdown
                                                                    useShortMonthInDropdown
                                                                    dropdownMode="select"
                                                                    peekNextMonth
                                                                    customInput={
                                                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                    }
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        {radioType == "N" ?
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>Remark</Form.Label>
                                                                    <Form.Control maxLength={100} placeholder='Remark' value={newRemark} onChange={e => Common.validateAlpNumValue(e.target.value, setNewRemark)} />
                                                                </Form.Group>
                                                            </Col> : null
                                                        }
                                                    </>
                                                    : radioType == "S" ?
                                                        <>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>From Srno<span className="colorThemeRed">*</span></Form.Label>
                                                                    <Form.Control type='text' maxLength={10} value={srnoFrom} onChange={e => Common.validateNumValue(e.target.value, setSrnoFrom)} />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>To srno<span className="colorThemeRed">*</span></Form.Label>
                                                                    <Form.Control type='text' maxLength={10} value={srnoTo} onChange={e => Common.validateNumValue(e.target.value, setSrnoTo)} />
                                                                </Form.Group>
                                                            </Col>
                                                        </>
                                                        : radioType == "A" ?
                                                            <>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>Status</Form.Label>
                                                                        <Form.Select value={approvalStatusFilter} onChange={e => setApprovalStatusFilter(e.target.value)}>
                                                                            <option value="P">Pending BM</option>
                                                                            <option value="B">Pending ZM</option>
                                                                            <option value="A">Approved</option>
                                                                        </Form.Select>
                                                                    </Form.Group>
                                                                </Col>
                                                                {
                                                                    approvalStatusFilter == "A" &&
                                                                    <>
                                                                        <Col className='col-md-3 col-6'>
                                                                            <Form.Group>
                                                                                <Form.Label>From Date</Form.Label>
                                                                                <DatePicker className="form-control"
                                                                                    selected={frmApprovalDate}
                                                                                    onChange={(date) => setFrmApprovalDate(date)}
                                                                                    dateFormat="dd/MM/yyyy"
                                                                                    showYearDropdown
                                                                                    showMonthDropdown
                                                                                    useShortMonthInDropdown
                                                                                    dropdownMode="select"
                                                                                    peekNextMonth
                                                                                    customInput={
                                                                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                                    }
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                        <Col className='col-md-3 col-6'>
                                                                            <Form.Group>
                                                                                <Form.Label>To Date</Form.Label>
                                                                                <DatePicker className="form-control"
                                                                                    selected={toApprovalDate}
                                                                                    onChange={(date) => setToApprovalDate(date)}
                                                                                    dateFormat="dd/MM/yyyy"
                                                                                    showYearDropdown
                                                                                    showMonthDropdown
                                                                                    useShortMonthInDropdown
                                                                                    dropdownMode="select"
                                                                                    peekNextMonth
                                                                                    customInput={
                                                                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                                    }
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </>
                                                                }
                                                            </>
                                                            : radioType == "H" && gstApproval2Right.query == "1"
                                                                ?
                                                                <>
                                                                    <Col className='col-md-3'>
                                                                        <Form.Group>
                                                                            <Form.Label>Status</Form.Label>
                                                                            <Form.Select value={hgstFilterStatus} onChange={e => handleFilterStatus(e.target.value)}>
                                                                                <option value="P">Pending</option>
                                                                                <option value="A">Approved</option>
                                                                            </Form.Select>
                                                                        </Form.Group>
                                                                    </Col>
                                                                </>
                                                                : null
                                            }
                                        </Row>
                                        <Row>&nbsp;</Row>
                                        <Row>
                                            <Col className='display-flex'>
                                                <>
                                                    {
                                                        userRight.query == "1" && radioType !== "N" && radioType !== "H" && radioType !== "A" && radioType !== "F" ?
                                                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => listCommissionHeader()}>List</Button> : null
                                                    }
                                                    &nbsp;
                                                    {
                                                        userRight.add == "1" && radioType == "N" ?
                                                            <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => headerSaveCheck()}>Add New</Button>
                                                            : null
                                                    }
                                                    &nbsp;
                                                    {
                                                        gstApprovalRight.query == "1" && radioType == "H" ?
                                                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => listHoldHGST()}>List Hold GST</Button>
                                                            : null
                                                    }
                                                    {
                                                        gstApproval2Right.query == "1" && radioType == "H" ?
                                                            // Gst Approval List
                                                            <>
                                                                <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => bmHdrList("GST", "ZM")}>List</Button>
                                                            </>
                                                            : null
                                                    }
                                                    {
                                                        zmApprovalRight.query == "1" && radioType == "A" &&
                                                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => bmHdrList("COMMISSION", "ZM")}>ZM Approval List</Button>
                                                    }
                                                    {
                                                        bmApprovalRight.query == "1" && radioType == "A" &&
                                                        <>&nbsp;
                                                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => bmHdrList("COMMISSION", "BM")}>BM Approval List</Button>
                                                        </>
                                                    }
                                                    {
                                                        (bmApprovalRight.query == "1" || zmApprovalRight.query == "1") && radioType == "A" &&
                                                        <>&nbsp;
                                                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => updateTransactionBMZM("A", "A")}>All Approve</Button>
                                                        </>
                                                    }
                                                </>
                                            </Col>
                                        </Row>
                                        <Row>&nbsp;</Row>
                                        <Row>
                                            {
                                                (bmApprovalRight.query == "1" || zmApprovalRight.query == "1" || gstApproval2Right.query == "1") && BMHeaderData.length > 0
                                                &&
                                                < Col >
                                                    <Table responsive striped bordered>
                                                        <thead>
                                                            <tr>
                                                                <th>&nbsp;</th>
                                                                <th>
                                                                    <div style={{ display: (approvalType == "ZM" && paymentType == "GST") && "none" }}>
                                                                        <span>All&nbsp;</span>
                                                                        <span><Form.Check type="checkbox" checked={selectAllBM} onChange={e => handleSelectAllBM(e.target.checked)} /></span>
                                                                    </div>
                                                                </th>
                                                                {/* <th>Srno</th> */}
                                                                <th>Location</th>
                                                                <th>Agent</th>
                                                                <th>Account Name</th>
                                                                <th>Account Number</th>
                                                                <th>IFSC</th>
                                                                {
                                                                    paymentType == "COMMISSION" ?
                                                                        <>
                                                                            <th>Pur Commission</th>
                                                                            <th>Sale Commission</th>
                                                                            <th>Net Margin</th>
                                                                            <th>Total Payable</th>
                                                                        </> :
                                                                        <>
                                                                            <th>Invoice Num</th>
                                                                            <th>Invoice Date</th>
                                                                            <th>GstIN</th>
                                                                            <th>SGST</th>
                                                                            <th>IGST</th>
                                                                            <th>CGST</th>
                                                                            <th>Total GST</th>
                                                                        </>
                                                                }
                                                                <th>Status</th>
                                                                <th style={{ display: approvalStatusFilter !== "A" && "none" }}>Approve Date</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                BMHeaderData.map((item, index) => (
                                                                    <tr>
                                                                        <td>
                                                                            <span onClick={() => viewBMHdrDetails(item)}
                                                                                className='handCursor colorThemeBlue'
                                                                            >
                                                                                <FontAwesomeIcon icon={faEye} />
                                                                            </span>
                                                                        </td>
                                                                        <td>
                                                                            <span style={{
                                                                                display: ((item.approval_type == "BM" && item.app_status != "P") ||
                                                                                    (item.approval_type == "ZM" && item.app_status != "B") ||
                                                                                    (approvalType == "ZM" && paymentType == "GST")) ? "none" : "block"
                                                                            }}>
                                                                                <Form.Check type="checkbox" checked={selectAllBM || item.selected == "1" && "checked"} onClick={(e) => updateCheckChangesBM("selected", index, e)} />
                                                                            </span>
                                                                        </td>
                                                                        {/* <td>{item.app_srno}</td> */}
                                                                        < td > {item.entity_name}</td>
                                                                        <td>{item.app_agent_code + " " + item.app_agent_name}</td>
                                                                        <td>{item.app_account_name}</td>
                                                                        <td>{item.app_account_no}</td>
                                                                        <td>{item.app_ifsc}</td>
                                                                        {
                                                                            paymentType == "COMMISSION" ?
                                                                                <>
                                                                                    <td>{item.app_commission_purchase}</td>
                                                                                    <td>{item.app_commission_sale}</td>
                                                                                    <td>{item.app_total_margin}</td>
                                                                                    <td>{item.app_payable}</td>
                                                                                    <td>{item.app_status == "A" ? "Approved" : item.app_status == "B" ? "Pending ZM" : "Pending BM"}</td>
                                                                                </>
                                                                                :
                                                                                <>
                                                                                    <td>{item.app_agent_invoice_num}</td>
                                                                                    <td>{item.app_agent_invoice_date}</td>
                                                                                    <td>{item.app_gstin}</td>
                                                                                    <td>{item.app_sgst}</td>
                                                                                    <td>{item.app_igst}</td>
                                                                                    <td>{item.app_cgst}</td>
                                                                                    <td>{1 * item.app_sgst + 1 * item.app_cgst + 1 * item.app_igst + item.app_ugst * 1}</td>
                                                                                    <td>{item.app_hgst_status == "P" ? "Pending" : "Approved"}</td>
                                                                                </>
                                                                        }
                                                                        <td style={{ display: approvalStatusFilter !== "A" && "none" }}>{item.app_approve_timestamp}</td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            }
                                            {
                                                userRight.query == "1" && hdrData.length > 0
                                                &&
                                                <Col>
                                                    <Table responsive striped bordered>
                                                        <thead>
                                                            <tr>
                                                                <th>&nbsp;</th>
                                                                <th>Srno</th>
                                                                <th>From Date</th>
                                                                <th>From To</th>
                                                                <th>Remark</th>
                                                                {/* <th>Status</th> */}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                hdrData.map(item => (
                                                                    <tr>
                                                                        <td>
                                                                            {
                                                                                userRight.edit == "1" &&
                                                                                <span onClick={() => viewHeaderDetails(item.hdr_srno, item.hdr_location, "0")} className='handCursor colorThemeBlue'>
                                                                                    <FontAwesomeIcon icon={faEdit} />
                                                                                </span>
                                                                            }
                                                                        </td>
                                                                        <td>{item.hdr_srno}</td>
                                                                        <td>{item.hdr_from_date}</td>
                                                                        <td>{item.hdr_to_date}</td>
                                                                        <td>{item.hdr_remark}</td>
                                                                        {/* <td>{item.hdr_status}</td> */}
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            }
                                            {
                                                gstApprovalRight.query == "1" && gstData.length > 0
                                                &&
                                                <Col>
                                                    <Table responsive striped bordered>
                                                        <thead>
                                                            <tr>
                                                                <th>&nbsp;</th>
                                                                <th>Agent Code</th>
                                                                <th>Agent Name</th>
                                                                <th>Invoice Num</th>
                                                                <th>Invoice Date</th>
                                                                <th>GstIn</th>
                                                                <th>SGST</th>
                                                                <th>CGST</th>
                                                                <th>IGST</th>
                                                                <th>UGST</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                gstData.map(item => (
                                                                    <tr>
                                                                        <td>
                                                                            <span onClick={() => viewHoldGstDetails(item.det_agent_code, item.det_srno, item.det_location, item.det_agent_name, item.sgst, item.cgst, item.igst, item.det_gstin, item.det_agent_invoice_num, item.det_agent_invoice_date)} className='handCursor colorThemeBlue'><FontAwesomeIcon icon={faEye} /></span>
                                                                        </td>
                                                                        <td>{item.det_agent_code}</td>
                                                                        <td>{item.det_agent_name}</td>
                                                                        <td>{item.det_agent_invoice_num}</td>
                                                                        <td>{item.det_agent_invoice_date}</td>
                                                                        <td>{item.det_gstin}</td>
                                                                        <td>{item.sgst}</td>
                                                                        <td>{item.cgst}</td>
                                                                        <td>{item.igst}</td>
                                                                        <td>{item.ugst}</td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            }
                                        </Row>
                                    </>
                                    //----------------- AM View----------------
                                    : scrMode == "Q" ?
                                        <>
                                            <Row>
                                                <Col className="col-md-2 col-4">
                                                    <span>Sr No : <b>{hdrSrno} </b></span>
                                                </Col>

                                                <Col className="col-md-2 col-4">
                                                    <span>Location : <b>{hdrLocation} </b></span>
                                                </Col>
                                                <Col className="col-md-2 col-4">
                                                    <span>From Date : <b>{hdrFromDateDMY}</b></span>
                                                </Col>
                                                <Col className="col-md-2 col-4">
                                                    <span>To Date : <b>{hdrToDateDMY}</b></span>
                                                </Col>
                                            </Row>
                                            <Row>&nbsp;</Row>
                                            <Row>
                                                <Col className='col-md-6'>
                                                    <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => setScrMode("")}>Back</Button>
                                                    &nbsp;
                                                    <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => finalDeleteBox()}>Delete Checked</Button>
                                                    &nbsp;
                                                    <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => openSendForApprovalModal()}>Send to Approval</Button>
                                                    &nbsp;
                                                    <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => updateInvoice()}>Update Invoice</Button>
                                                    &nbsp;
                                                </Col>
                                                {/* <Col style={{ textAlign: "right" }}>
                                                    <Button variant='warning' className='buttonStyle' size='sm' onClick={() => viewHeaderDetails(hdrSrno, cmLocationValue, "1")}>Update Agent Changes</Button>
                                                </Col> */}
                                            </Row>
                                            <Row>&nbsp;</Row>
                                            <Row>
                                                <Col>
                                                    {
                                                        (userRight.query == "1" && (scrMode == 'E' || scrMode == 'Q')) ?
                                                            <><Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                                btnActivityLog("AM")}>Activity Log</Button>&nbsp;</>
                                                            : null
                                                    }
                                                    {
                                                        Common.fetchCommission ?
                                                            <>
                                                                <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => getFaDetail("COMMISSION")}>Fetch&Write Commission FA</Button>&nbsp;
                                                                &nbsp;
                                                                <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => getFaDetail("GST")}>Fetch&Write GST FA</Button>&nbsp;
                                                            </>
                                                            :
                                                            <>
                                                                <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => downloadFAModal("COMMISSION")}>Download Commission FA</Button>
                                                                &nbsp;
                                                                <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => downloadFAModal("GST")}>Download GST FA</Button>&nbsp;
                                                            </>
                                                    }
                                                </Col>
                                            </Row>

                                            <Row>&nbsp;</Row>
                                            <hr />
                                            <Row>
                                                <Col className='col-md-4 col-6'>
                                                    <Form.Group>
                                                        <Row style={{ marginTop: "30px" }}>
                                                            <Col style={{ display: "flex" }}>
                                                                <Form.Check checked={childRadioType == "U"} onChange={() => setChildRadioType("U")} type='radio' label="Upload" />
                                                                &nbsp;
                                                                <Form.Check checked={childRadioType == "F"} onChange={() => setChildRadioType("F")} type='radio' label="Filter" />
                                                                &nbsp;
                                                                <span>
                                                                    <Badge bg="secondary" className="handCursor" onClick={() => summarizeCommission("O")}>Summary</Badge>
                                                                </span>
                                                            </Col>
                                                        </Row>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            {
                                                childRadioType == "U" ?
                                                    <>
                                                        <Row>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>Type&nbsp;
                                                                        {reportType == "OC" && <Badge bg="primary" className="handCursor" onClick={downloadDirectExpenseFormat}>Format</Badge>}
                                                                    </Form.Label>
                                                                    <Form.Select value={reportType} onChange={e => setReportType(e.target.value)}>
                                                                        {/* <option value="TW">Transaction Wise</option>
                                                                        <option value="CW">Commission Wise</option> */}
                                                                        <option value="OC">Other Commission</option>
                                                                    </Form.Select>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group controlId='uploadCommission'>
                                                                    <Form.Label>File* (MAX 10MB)</Form.Label>
                                                                    <Form.Control type='file' value={nFile} onChange={e => handleFileChange(e.target.value)} />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className='col-md-3 col-6'>
                                                                <Button style={{ marginTop: "33px" }} variant='outline-primary' className='buttonStyle' size='sm' onClick={() => uploadFile()}>Upload</Button>
                                                            </Col>
                                                            {
                                                                Common.fetchCommission &&
                                                                <Col className='col-md-3 col-6'>
                                                                    <Button style={{ marginTop: "33px" }} variant='outline-primary' className='buttonStyle' size='sm' onClick={() => fetchCommssions()}>Fetch</Button>
                                                                </Col>
                                                            }
                                                        </Row>
                                                        <Row style={{ fontSize: "13px" }}>Please upload transaction wise report before commission report.
                                                        </Row>
                                                    </>
                                                    :
                                                    <Row>
                                                        <Col className='col-md-3 col-6'>
                                                            <Form.Group>
                                                                <Form.Label>Search..<span className="handCursor colorThemeBlue" title="Help"
                                                                    onClick={(e) => showSearchOptions()}><FontAwesomeIcon icon={faInfoCircle} />
                                                                </span>
                                                                </Form.Label>
                                                                <Form.Control placeholder='Search' type='text' value={searchFilter} onChange={e => handleSearchChange(e.target.value)} />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col className='col-md-3 col-6'>
                                                            <Form.Group>
                                                                <Form.Label>Status</Form.Label>
                                                                <Form.Select value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
                                                                    <option value="1">All</option>
                                                                    <option value="P">Pending</option>
                                                                    <option value="O">Ok</option>
                                                                    <option value="A">Approve</option>
                                                                    <option value="R">Rejected</option>
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col className='col-md-3 col-6'>
                                                            <Form.Group>
                                                                <Form.Label>Gst Type</Form.Label>
                                                                <Form.Select value={filterGstType} onChange={e => setFilterGstType(e.target.value)}>
                                                                    <option value="1">All</option>
                                                                    <option value="WOGST">Without GST</option>
                                                                    <option value="HGST">Hold GST</option>
                                                                    <option value="WGST">With GST</option>
                                                                </Form.Select>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col className='col-md-3 col-6'>
                                                            <Button style={{ marginTop: "33px" }} variant='outline-primary' size='sm' className='buttonStyle' onClick={() => searchCommission("S")}>Search</Button>
                                                            &nbsp;
                                                            <Button style={{ marginTop: "33px" }} variant='outline-success' size='sm' className='buttonStyle' onClick={() => searchCommission("R")}>Reset</Button>
                                                        </Col>
                                                    </Row>
                                            }
                                            <Row>&nbsp;</Row>
                                            <Row>
                                                <Col>
                                                    <Table responsive striped bordered>
                                                        <thead>
                                                            <tr>
                                                                <th className='commissionCheck'>
                                                                    <span>All&nbsp;</span>
                                                                    <span><Form.Check type="checkbox" checked={selectAll} onChange={e => handleSelectAll(e.target.checked)} /></span></th>
                                                                <th>Action</th>
                                                                <th>Status</th>
                                                                <th>Group</th>
                                                                <th>Agent</th>
                                                                <th>Gst Type</th>
                                                                <th>Fa Type</th>
                                                                {
                                                                    flag &&
                                                                    <>
                                                                        <th>Invoice Number</th>
                                                                        <th>Invoice Date</th>
                                                                    </>
                                                                }
                                                                <th>Cert No</th>
                                                                {/*<th>Client Name</th>
                                                                <th>ISD</th> */}
                                                                <th>Tran Date</th>
                                                                <th>Net Margin</th>
                                                                <th>Commission</th>
                                                                <th>IGST</th>
                                                                <th>CGST</th>
                                                                <th>SGST</th>
                                                                <th>TDS</th>
                                                                <th>TDS %</th>
                                                                <th>Total Payable</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                commissionData.map((item, index) => (
                                                                    <>
                                                                        <tr key={item.det_cert_no}>
                                                                            <td>
                                                                                <div style={{ display: item.det_submit_approval == "1" || item.det_fa_type == "NOFA" ? "none" : "block" }}>
                                                                                    <div style={{ display: "flex" }}>
                                                                                        <span>
                                                                                            <Form.Check type="checkbox" checked={selectAll || item.selected == "1" && "checked"} onClick={(e) => updateCheckChanges("selected", index, e)} />
                                                                                        </span>&nbsp;
                                                                                        {
                                                                                            item.det_agent_name == "" &&
                                                                                            <span title='Add Agent Details' className='handCursor colorThemeBlue' onClick={() => agentDetailsForm(item.det_agent_code)}>
                                                                                                <FontAwesomeIcon icon={faEdit} />
                                                                                            </span>
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td className='commissionCheck'>
                                                                                {
                                                                                    item.det_submit_approval == "1" || item.det_fa_type == "NOFA" ? null
                                                                                        :
                                                                                        <>
                                                                                            <span className='handCursor' title="Ok" style={{ color: "green" }}>
                                                                                                <FontAwesomeIcon icon={faCircleCheck} onClick={() => updateStatus("O", item.det_srno, item.det_lineno, item.det_location, item.det_cert_no, item.det_type)} />
                                                                                            </span>
                                                                                            {/* &nbsp;&nbsp;
                                                                <span className='handCursor' style={{ color: "red" }} title="Reject">
                                                                    <FontAwesomeIcon icon={faCircleXmark} onClick={() => updateStatus("R", item.det_srno, item.det_lineno, item.det_location, item.det_cert_no)} />
                                                                </span> */}
                                                                                            &nbsp;&nbsp;
                                                                                            <span className='handCursor colorThemeBlue' title="Hold">
                                                                                                <FontAwesomeIcon icon={faCircleExclamation} onClick={() => updateStatus("H", item.det_srno, item.det_lineno, item.det_location, item.det_cert_no, item.det_type)} />
                                                                                            </span>
                                                                                        </>
                                                                                }
                                                                            </td>
                                                                            <td style={{ backgroundColor: item.det_status == "H" && "#F0E68C" }}>{item.det_status == "P" ? "Pending" :
                                                                                item.det_status == "R" ? "Rejected" :
                                                                                    item.det_status == "A" ? "Approve" :
                                                                                        item.det_status == "H" ? "Hold" :
                                                                                            item.det_status == "O" ? "Ok" : ""}</td>
                                                                            <td>{item.det_group}</td>
                                                                            <td style={{ backgroundColor: (1 * item.det_commission_total - Math.round(item.det_commission_total * 0.05)) < 0 && "red" }}>
                                                                                {item.det_agent_code + ' ' + item.det_agent_name}
                                                                            </td>
                                                                            <td>{item.det_gst_type}</td>
                                                                            <td>{item.det_fa_type}</td>
                                                                            {flag &&
                                                                                <>
                                                                                    <td>{item.det_agent_invoice_num}</td>
                                                                                    <td>{item.det_agent_invoice_date}</td>
                                                                                </>
                                                                            }
                                                                            {
                                                                                item.det_cert_no == "0" ?
                                                                                    <td>{item.det_key}</td>
                                                                                    : <td>{item.det_type + " " + item.det_cert_no}</td>
                                                                            }
                                                                            {/* <td>{item.det_client_name}</td> */}
                                                                            {/* <td>{item.det_isd}</td> */}
                                                                            <td>{item.det_tran_date}</td>
                                                                            <td>{item.det_total_margins}</td>
                                                                            <td>{item.det_commission_total}</td>
                                                                            <td>{item.det_igst}</td>
                                                                            <td>{item.det_cgst}</td>
                                                                            <td>{item.det_sgst}</td>
                                                                            <td>{item.det_tds}</td>
                                                                            <td className={item.det_tds_percentage !== "0.02" ?
                                                                                'bg-danger text-white' : ''}>
                                                                                {item.det_tds_percentagevalue}</td>
                                                                            <td>{item.det_commission_net}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td colSpan={17}>
                                                                                Account No: <b>{item.det_account_no},</b>
                                                                                &nbsp;
                                                                                IFSC: <b>{item.det_ifsc},</b>
                                                                                &nbsp;
                                                                                Account Name: <b>{item.det_account_name}</b>
                                                                            </td>
                                                                        </tr>
                                                                    </>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                        </>
                                        //-------------- BM detail View--------------------
                                        : scrMode == "BmQ" ?
                                            <>
                                                <Row>
                                                    <Col className="col-md-2 col-4">
                                                        <span>Location : <b>{hdrLocation} </b></span>
                                                    </Col>
                                                    <Col className="col-md-2 col-4">
                                                        {
                                                            paymentType == "COMMISSION" ?
                                                                <span>Status : <b>{bmStatus == "A" ? "Approved" : bmStatus == "B" ? "Pending ZM" : "Pending BM"}</b></span>
                                                                :
                                                                <span>Status : <b>{gstStatus == "A" ? "Approved" : "Pending"}</b></span>
                                                        }
                                                    </Col>
                                                    <Col className="col-md-4 col-4">
                                                        <span>Agent : <b>{bmAppAgent}</b></span>
                                                    </Col>
                                                    <Col className="col-md-2 col-4">
                                                        <span>Account No : <b>{bmAccount}</b></span>
                                                    </Col>
                                                    <Col className="col-md-2 col-4">
                                                        <span>IFSC : <b>{bmIfsc}</b></span>
                                                    </Col>
                                                </Row>
                                                <Row>&nbsp;</Row>
                                                {
                                                    paymentType == "COMMISSION" ?
                                                        <Row>
                                                            <Col className="col-md-2 col-4">
                                                                <span>GST Type : <b>{bmGSTType}</b></span>
                                                            </Col>
                                                            <Col className="col-md-2 col-4">
                                                                <span>FA Type : <b>{bmFaType}</b></span>
                                                            </Col>
                                                            <Col className="col-md-2 col-4">
                                                                <span>Total Commission : <b>{bmAppTotalCommission}</b></span>
                                                            </Col>
                                                            <Col className="col-md-2 col-4">
                                                                <span>GST : <b>{bmGST}</b></span>
                                                            </Col>
                                                            <Col className="col-md-2 col-4">
                                                                <span>TDS : <b>{bmAppTotalTds}</b></span>
                                                            </Col>
                                                            <Col className="col-md-2 col-4">
                                                                <span>Net Payable : <b>{bmAppTotalPayable}</b></span>
                                                            </Col>
                                                        </Row>
                                                        :
                                                        <Row>
                                                            <Col className="col-md-2 col-4">
                                                                <span>Invoice Number : <b>{bmInvoiceNum}</b></span>
                                                            </Col>
                                                            <Col className="col-md-2 col-4">
                                                                <span>Invoice Date : <b>{bmInvoiceDate}</b></span>
                                                            </Col>
                                                            <Col className="col-md-2 col-4">
                                                                <span>GstIN : <b>{hdrGstin}</b></span>
                                                            </Col>
                                                            <Col className="col-md-2 col-4">
                                                                <span>Total GST : <b>{bmGST}</b></span>
                                                            </Col>
                                                        </Row>

                                                }
                                                <Row>&nbsp;</Row>
                                                <Row>
                                                    <Col className='col-md-6'>
                                                        <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => setScrMode("")}>Back</Button>
                                                        &nbsp;
                                                        {
                                                            (paymentType == "COMMISSION" && ((approvalType == "BM" && bmStatus !== "P") || (approvalType == "ZM" && bmStatus !== "B")))
                                                                || (paymentType == "GST" && gstStatus == "A") ? null
                                                                :
                                                                <>
                                                                    <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => updateTransactionBMZM("A", "O")}>Approve</Button>
                                                                    &nbsp;
                                                                    <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => updateTransactionBMZM("R", "O")}>Reject</Button>
                                                                </>
                                                        }
                                                        {
                                                            bmApprovalRight.query == "1" ? <>
                                                                &nbsp;
                                                                <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                                    btnActivityLog("BM")}>Activity Log</Button>&nbsp;
                                                            </> : null
                                                        }
                                                    </Col>
                                                </Row>
                                                <Row>&nbsp;</Row>
                                                <Row>
                                                    <Col>
                                                        <Table responsive striped bordered>
                                                            <thead>
                                                                <tr>
                                                                    {/* <th className='commissionCheck'>
                                                            <span>All&nbsp;</span>
                                                            <span><Form.Check type="checkbox" checked={selectAllBM} onChange={e => handleSelectAllBM(e.target.checked)} /></span>
                                                        </th> */}
                                                                    <th>Agent</th>
                                                                    <th>Cert No</th>
                                                                    <th>Client Name</th>
                                                                    <th>ISD</th>
                                                                    <th>Tran Date</th>
                                                                    {
                                                                        paymentType == "COMMISSION" ?
                                                                            <>
                                                                                <th>Net Margin</th>
                                                                                <th>Commission</th>
                                                                                <th>TDS</th>
                                                                                <th>Total Payable</th>
                                                                            </>
                                                                            :
                                                                            <>
                                                                                <th>sgst</th>
                                                                                <th>cgst</th>
                                                                                <th>igst</th>
                                                                                <th>Total Gst</th>
                                                                            </>
                                                                    }
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    bmDetailData.map((item, index) => (
                                                                        <tr key={item.det_cert_no}>
                                                                            {/* <td>
                                                                    <span>
                                                                        <Form.Check type="checkbox" checked={selectAllBM || item.selected == "1" && "checked"} onClick={(e) => updateCheckChangesBM("selected", index, e)} />
                                                                    </span>
                                                                </td> */}
                                                                            <td>{item.det_agent_code + ' ' + item.det_agent_name}</td>
                                                                            <td>{item.det_type + " " + item.det_cert_no}</td>
                                                                            <td>{item.det_client_name}</td>
                                                                            <td>{item.det_isd}</td>
                                                                            <td>{item.det_tran_date}</td>
                                                                            {
                                                                                paymentType == "COMMISSION" ?
                                                                                    <>
                                                                                        <td>{item.det_total_margins}</td>
                                                                                        <td>{item.det_commission_total}</td>
                                                                                        <td>{item.det_tds}</td>
                                                                                        <td>{item.det_commission_net}</td>
                                                                                    </>
                                                                                    :
                                                                                    <>
                                                                                        <td>{item.det_sgst}</td>
                                                                                        <td>{item.det_cgst}</td>
                                                                                        <td>{item.det_igst}</td>
                                                                                        <td>{item.det_sgst * 1 + item.det_cgst * 1 + item.det_igst * 1}</td>
                                                                                    </>
                                                                            }

                                                                        </tr>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </Table>
                                                    </Col>
                                                </Row>
                                            </>
                                            :
                                            scrMode == "GST" ?
                                                <Tran_commission_gst_approval obj={propObject} holdGstData={holdGstData} />
                                                : null
                            }
                        </Container >
                    </>
            }
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Modal show={showSummaryModal} size='xl' onHide={() => setShowSummaryModal(false)} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <Row>
                            <Col>
                                <span>Payable Summary</span>
                                <span>&nbsp;</span>
                                <span className="handCursor colorThemeBlue" onClick={downloadSummary}><FontAwesomeIcon icon={faDownload} /></span>
                            </Col>
                        </Row>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col className="col-md-5">
                            <Form.Group>
                                <Form.Label>Status&nbsp;
                                </Form.Label>
                                <Form.Select value={summaryStatusFilter} onChange={(e) => summarizeCommission(e.target.value)} >
                                    <option value="ALL">ALL</option>
                                    <option value="O">OK</option>
                                    <option value="A">APPROVE</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>&nbsp;</Row>
                    <Row>
                        <Col>
                            <span>Total Commission: <b>{summaryCommissionTotal}</b></span>&nbsp;&nbsp;
                            <span>Total TDS: <b>{summaryTDSTotal}</b></span>&nbsp;&nbsp;
                            <span>Total Payable: <b>{summaryPayable}</b></span>
                        </Col>
                    </Row>
                    <Row>
                        <Table striped responsive bordered>
                            <thead>
                                <tr>
                                    <th>Agent Group</th>
                                    <th>Agent Code</th>
                                    <th>Agent Name</th>
                                    <th>GST Type</th>
                                    <th>FA Type</th>
                                    <th>Pur Commission</th>
                                    <th>Sale Comission</th>
                                    <th>Net Margin(Sale)</th>
                                    <th>Total Commission</th>
                                    <th>Total TDS</th>
                                    <th>Total GST</th>
                                    <th>Total Payable</th>
                                    <th>BM Approved</th>
                                    <th>ZM Approved</th>
                                    <th>Payment</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    commissionSummary.map(item => (
                                        <tr key={item.det_agent_code}>
                                            <td>{item.det_group}</td>
                                            <td>{item.det_agent_code}</td>
                                            <td>{item.det_agent_name}</td>
                                            <td>{item.det_gst_type}</td>
                                            <td>{item.det_fa_type}</td>
                                            <td>{item.det_commission_purchase}</td>
                                            <td>{item.det_commission_sale}</td>
                                            <td>{item.totalmargin}</td>
                                            <td>{item.totalcommission}</td>
                                            <td>{item.totaltds}</td>
                                            <td>{1 * item.det_igst + 1 * item.det_cgst + 1 * item.det_sgst}</td>
                                            <td>{item.netcommission}</td>
                                            <td>{item.det_bm_approved == "1" ? "YES" : "NO"}</td>
                                            <td>{item.det_zm_approved == "1" ? "YES" : "NO"}</td>
                                            <td>{item.tmp_status == "D" ? "Done" : item.tmp_status == "NP" ? "N/A" : "Pending"}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </Table>
                    </Row>
                </Modal.Body>
            </Modal>
            <Modal show={openFaModal} size='lg' onHide={() => setOpenFaModal(false)} backdrop="static">
                <Modal.Header closeButton>
                    Download Type : {faType}
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col className='col-6'>
                            <Form.Group>
                                <Form.Select value={faDownloadType} onChange={e => setFaDownloadType(e.target.value)}>
                                    <option value="N">New</option>
                                    <option value="A">All</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>&nbsp;</Row>
                    <Row>
                        <Col>
                            <Button className='col-md-6' variant='outline-primary' onClick={finalDownloadFa}>Download</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
            <Modal show={showInvoiceModal} size='xl' onHide={() => setShowInvoiceModal(false)} backdrop="static">
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Table striped bordered>
                            <thead>
                                <tr>
                                    <th>Agent Code</th>
                                    <th>Commission</th>
                                    <th>TDS</th>
                                    <th>GST</th>
                                    <th>Net Payable</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    invoiceData.map((item, index) => (
                                        <>
                                            <tr>
                                                <td>{item.det_agent_code + " " + item.det_agent_name}</td>
                                                <td>{item.totalcommission}</td>
                                                <td>{item.totaltds}</td>
                                                <td>{item.det_igst * 1 + item.det_cgst * 1 + item.det_sgst * 1}</td>
                                                <td>{item.netcommission}</td>
                                            </tr>
                                            <tr>
                                                <td colSpan={15}>
                                                    <Row>
                                                        <Col className="col-md-3 col-6">
                                                            <Form.Group>
                                                                <Form.Label>Invoice Number</Form.Label>
                                                                <Form.Control type='text' maxLength={50} name='invoicenum' value={item.invoicenum} onChange={e => updateInvoiceValues(e.target.value, index, 'invoicenum')} />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col className="col-md-3 col-6">
                                                            <Form.Group>
                                                                <Form.Label>Invoice Date</Form.Label>
                                                                <DatePicker className="form-control"
                                                                    selected={item.invoicedate == null ? null : new Date(item.invoicedate)}
                                                                    onChange={(date) => updateInvoiceValues(Common.dateYMD(date), index, "invoicedate")}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    showYearDropdown
                                                                    showMonthDropdown
                                                                    useShortMonthInDropdown
                                                                    dropdownMode="select"
                                                                    peekNextMonth
                                                                    customInput={
                                                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                    }
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                </td>
                                            </tr>
                                        </>
                                    ))
                                }
                            </tbody>
                        </Table>
                    </Row>
                    <Row>&nbsp;</Row>
                    <Row>
                        <Col className='col-md-6'>
                            <Button variant='outline-primary' size='sm' className='buttonStyles' onClick={() => finalUpdateInvoice()}>Update</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
            <Modal show={openApprovalModal} size='xl' onHide={() => setOpenApprovalModal(false)} backdrop="static">
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Table responsive bordered striped>
                            <thead>
                                <tr>
                                    <th>Agent</th>
                                    <th>GST Type</th>
                                    <th>Commission</th>
                                    <th>TDS</th>
                                    <th>GST</th>
                                    <th>Net Payable</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    approvalSummary.map((item, index) => (
                                        <tr index={item.det_group + " " + item.det_agent_code}>
                                            <td>{item.det_group + " " + item.det_agent_code + " " + item.det_agent_name}</td>
                                            <td>{item.app_gst_type}</td>
                                            <td>{item.app_total_commission}</td>
                                            <td>{item.app_tds}</td>
                                            <td>{item.app_igst * 1 + item.app_sgst * 1 + item.app_cgst * 1}</td>
                                            <td>{item.app_payable}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </Table>
                    </Row>
                    <Row>
                        <Button variant='primary' onClick={sendForApproval}>Send For Approval</Button>
                    </Row>
                </Modal.Body>
            </Modal>
            <Modal show={showFaSummary} size='xl' onHide={() => setShowFaSummary(false)} backdrop="static">
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Table responsive bordered striped>
                            <thead>
                                <tr>
                                    <th>Line No</th>
                                    <th>Date</th>
                                    <th>Narration</th>
                                    <th>Ref No</th>
                                    <th>Flag</th>
                                    <th>Group</th>
                                    <th>Account</th>
                                    <th>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    faSummary.map((item, index) => (
                                        <tr key={item.tmcfa_line_no}>
                                            <td>{item.tmcfa_line_no}</td>
                                            <td>{item.formatted_date}</td>
                                            <td>{item.tmcfa_narration}</td>
                                            <td>{item.tmcfa_refno}</td>
                                            <td>{item.tmcfa_credit_debit}</td>
                                            <td>{item.tmcfa_group}</td>
                                            <td>{item.tmcfa_account}</td>
                                            <td>{item.tmcfa_amount}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </Table>
                    </Row>
                    <Row>
                        <Col className='col-md-4'>
                            <Button variant='danger' onClick={() => writeFinancialEntry("1")}>Upload</Button>&nbsp;
                            <Button variant='primary' onClick={() => setShowFaSummary(false)}>Cancel</Button>&nbsp;
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <DialogYesNo isOpen={isMsgBoxFinal} onYes={(e) => finalCheck()} onNo={(e) => setMsgBoxFinal(false)}>
                {msgTextFinal}
            </DialogYesNo>
            <DialogYesNo isOpen={isMsgBoxFinalFaWrite} onYes={(e) => writeFinancialEntry("0")} onNo={(e) => setMsgBoxFinalFaWrite(false)}>
                {msgTextFinalFaWrite}
            </DialogYesNo>
            <ActivityLog logObject={logObject} show={showActivityLog} onHide={hideActivityLog} />
        </>
    )
}

export default Tran_commission_module
